import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="w-full bg-[#F7F2E7] py-20 px-6" style={{
    backgroundColor: "#F7F2E7",
    backgroundImage: "none"
  }} data-id="element-172" data-mp="38xojqxoaaow2">
      <div className="max-w-3xl mx-auto" data-id="element-173" data-mp="2uyx61cdc358g">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6 text-lg md:text-xl leading-relaxed text-[#0A1535]" data-id="element-174" data-mp="2uxvsn18ui6nk">
          <h2 className="font-bold text-xl sm:text-2xl md:text-3xl text-[#0A1535] mb-2 leading-snug [text-wrap:balance]" data-id="element-175" data-mp="2pzudusigcthw">
            ¿Alguna vez has sentido que amas a Dios…
          </h2>

          <p className="pl-8 text-gray-700 italic" data-id="element-176" data-mp="2gaauzmuqozn1">
            …pero aun así vives preocupada?
          </p>

          <p data-id="element-177" data-mp="22asysmf46k3n">Que oras y sigues sintiéndote cansada emocionalmente.</p>

          <p data-id="element-178" data-mp="2792vj1ghlsrd">
            Que lees Sus promesas, pero el miedo y la incertidumbre parecen más
            fuertes que tu fe.
          </p>

          <p data-id="element-179" data-mp="3rlfz3u5tt98s">
            Que intentas confiar, pero tu mente no deja de pensar en los
            problemas, las deudas, el futuro o las situaciones que aún no tienen
            respuesta.
          </p>

          <div className="pt-2 space-y-1" data-id="element-180" data-mp="5f17icsa8s4e">
            <p className="font-semibold" data-id="element-181" data-mp="gzh16sj1qiw">Por fuera sigues adelante.</p>
            <p data-id="element-182" data-mp="ewq8kjjvtd4">Sonríes.</p>
            <p data-id="element-183" data-mp="38w9lumnsx9ud">Trabajas.</p>
            <p data-id="element-184" data-mp="38xkouk9fadkf">Cuidas de los demás.</p>
          </div>

          <p className="font-semibold text-[#C9A24B]" data-id="element-185" data-mp="33xgb31zwfwxw">
            Pero por dentro estás agotada.
          </p>

          <p data-id="element-186" data-mp="3im2qf3pj0op4">Y aunque sigues creyendo en Dios…</p>

          <p className="italic text-gray-700" data-id="element-187" data-mp="3inni8lkghtja">
            extrañas la paz que alguna vez sentiste.
          </p>

          <p className="italic text-gray-700" data-id="element-188" data-mp="3dtjaw17a3jho">
            Extrañas esa tranquilidad de saber que Dios tiene el control.
          </p>
        </motion.div>
      </div>
    </section>;
}